import ImportDescription from 'components/ImportDescription/ImportDescription'

export default ImportDescription
